import { render, staticRenderFns } from "./SentencesList.vue?vue&type=template&id=492767b4&scoped=true"
import script from "./SentencesList.vue?vue&type=script&lang=js"
export * from "./SentencesList.vue?vue&type=script&lang=js"
import style0 from "./SentencesList.vue?vue&type=style&index=0&id=492767b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492767b4",
  null
  
)

export default component.exports